/**
 * Returns the canonical URL path for a blog post based on its type.
 *
 * - SDN posts   → /blogs/spicy-date-nights/<slug>
 * - DBRT posts  → /blogs/diary-of-a-baby-rope-top/<slug>
 * - General     → /blogs/<slug>
 */
export function getBlogPostPath(slug: string, blogType?: string): string {
  if (blogType === 'sdn') return `/blogs/spicy-date-nights/${slug}`
  if (blogType === 'dbrt') return `/blogs/diary-of-a-baby-rope-top/${slug}`
  return `/blogs/${slug}`
}

/** Maps blog_type codes to their category archive paths */
export const BLOG_TYPE_ARCHIVE: Record<string, string> = {
  sdn: '/blogs/spicy-date-nights',
  dbrt: '/blogs/diary-of-a-baby-rope-top',
}

/** Maps blog_type codes to human-readable labels */
export const BLOG_TYPE_LABELS: Record<string, string> = {
  sdn: 'Spicy Date Nights',
  dbrt: 'Diary of a Baby Rope Top',
  general: 'General',
}
